import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../femcare-content.json";
import SymptomChecker from "../components/Home/SymptomTracker";
import CheckSymptoms from "../components/Home/WhatStages";
import MeetDoctors from "../components/Home/MeetDoctors";
import KeyServices from "../components/Home/KeyServices";
import HealthPrograms from "../components/Home/HealthPrograms";
import WhyTrustUs from "../components/Home/WhyTrustUs";
import Testimonials from "../components/Home/Testimonals";
import CallToAction from "../components/common/CTASection";
import PatientJourney from "../components/Home/PatientsJourney";
import useCurrentLocation from '../hooks/useCurrentLocation';
import DigitalHealthFAB from "../components/Digitalhealth";
import DoctorsList from "../components/OurDoctors/DoctorsList";
import BookAppointment from "../components/Appointments/BookAppointment";
import doctorData from "../appointments.json";

import { useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import TalkToCareGuideButton from "../components/whatsapp/whatsappIntegration";
import { BASE_URL } from "../api/apiClient";
import TrustBadges from "../components/Home/TrustBadgeHome";


const { slides } = data.sections.hero;

const Home = () => {
  const location = useCurrentLocation();
  const FEMCARE_API_URL = `${BASE_URL}/api/femcare/?clinic=mukta`;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [heroData, setHeroData] = useState({});
  console.log(location);
  const [searchParams] = useSearchParams();
  const autoOpenRef = useRef(null); // BookAppointment exposes its open trigger here

  useEffect(() => {
    if (searchParams.get("openModal") === "true") {
      // Small delay to ensure BookAppointment has mounted and registered the ref
      const timer = setTimeout(() => {
        autoOpenRef.current?.();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);
  // console.log("vvvvv",data)
  useEffect(() => {
    let cancelled = false;

    fetch(FEMCARE_API_URL)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch navbar: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        // setNavbar(data.navbar);
        setHeroData(data?.sections?.hero?.slides?.slice(0, 1))
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Fragment>
      <DigitalHealthFAB />
      <HeroSection
        //  slides={slides} 
        slides={heroData}
        autoPlayInterval={13000}
      />
      <CheckSymptoms />
      <KeyServices />
      <SymptomChecker />
      {/* <MeetDoctors /> */}
      {/* <DoctorsList/> */}
      <div>
        <h2 className="ava-heading-lg text-center ava-heading-gap ">Meet Our Healthcare Expert</h2>
        <BookAppointment data={doctorData.bookAppointment}
          autoOpenRef={autoOpenRef} />
      </div>
      <HealthPrograms />
      {/* <WhyTrustUs /> */}
      <TrustBadges/>
      <PatientJourney />
      <Testimonials />
      {/* <TalkToCareGuideButton/> */}
      <CallToAction data={data?.callToAction} />
    </Fragment>
  );
};

export default Home;